import { requestMfaProcedureSuccess } from 'common/components/ModalMFA/actions';
import type { AppDispatch } from 'modules/app/redux/store';
import type { AuthenticationMethod } from 'modules/authentication-factor/models/authenticationFactors';
import { postV2ApiCardsPaymentPasswordShow } from 'src/client/spendesk-api';
import { type PostV2ApiCardsPaymentPasswordShowResponseOK } from 'src/client/spendesk-api-types';

type PostShowPaymentPasswordRequestInput = {
  authenticationMethod: AuthenticationMethod;
};

export const postShowPaymentPassword = async (
  { authenticationMethod }: PostShowPaymentPasswordRequestInput,
  // Dispatching is only used for the SMS fallback flow.
  dispatch?: AppDispatch,
): Promise<PostV2ApiCardsPaymentPasswordShowResponseOK> => {
  const response = await postV2ApiCardsPaymentPasswordShow({
    body: {
      authenticationMethod,
    },
  });
  if (response.statusCode === 200) {
    const { procedureId, factorId } = response.body;

    if (authenticationMethod === 'mfa' && factorId) {
      // Dispatching so that it would be used by ModalMFAToken
      dispatch(
        requestMfaProcedureSuccess({
          id: procedureId,
          factorId,
        }),
      );
    }

    return {
      procedureId,
      factorId,
    };
  }
  throw new Error('Show Payment password failed');
};
